export default __webpack_public_path__ + "static/media/basket.80c18f49.svg";